import { css } from "@emotion/react";
import styled from "../../../config/emotion";

export const inputCss = css`
  margin: 5px;
`;

export const ButtonText = styled.div`
  padding-left: 8px;
`;

export const DataActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0;
  align-items: center;
`;

export const resetBtn = css`
  padding-left: 26px;
  padding-right: 26px;
  white-space: nowrap;
  margin: 5px;
`;

export const moreButtonCss = css`
  box-shadow: none;
`;
